import axios from 'axios'
import qs from 'qs'
// import baseurl from 'baseurl'
const service = axios.create({
    baseURL: "/zjservice",
    timeout: 10000 // request timeout
})
service.defaults.headers.post['Content-Type'] = 'multipart/form-data'

service.interceptors.request.use(
    config => {
        // if (config.isFile) {
        //     config.headers['Content-Type'] = 'multipart/form-data'
        // }
        // config.data = qs.stringify(config.data);
        return config
    },
    error => {
        Promise.reject(error)
    }
)

// response interceptor
service.interceptors.response.use(
    response => {
        const res = response.data
        return response.data
    },
    error => {
        return Promise.reject(error)
    }
)

export default service


// WEBPACK FOOTER //
// ./src/unit/requestfile.js